import { Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const { confirm } = Modal;

export default function Confirmation(title, message, onApprove, onCancels) {
  confirm({
    title: title,
    icon: <ExclamationCircleOutlined />,
    content: message,
    okText: "Yes",
    cancelText: "No",

    centered: true, // <== Center popup
    maskClosable: false, // <== Cannot click outside to close
    keyboard: false, // <== Cannot close with ESC key

    okButtonProps: {
      style: { backgroundColor: "green", borderColor: "green" },
    },
    cancelButtonProps: {
      style: { backgroundColor: "red", borderColor: "red", color: "#fff" },
    },

    onOk() {
      onApprove();
    },

    onCancel() {
      return onCancels ? onCancels() : null;
    },
  });
}
